// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7867":"css/app.6972","8756":"css/admin-app.6972"}[chunkId] + ".css";
};